import cookie from "js-cookie";
import { useEffect, useState } from "react";
import server, { uploadServer } from "../../api/server";
import { toast } from "react-toastify";
import Loader from "../../components/shared/Loader";
import { updateMeta } from "../../store/actions/metaAction";
import { useDispatch } from "react-redux";

export default function Testmonials() {
	const dispatch = useDispatch();
	const [loading, setLoading] = useState(false);
	const [data, setData] = useState({});

	useEffect(() => {
		dispatch(
			updateMeta({
				title: "خلفية اراء العملاء",
				breadcrumb: "الخلفيات",
				button: {
					show: false,
					text: null,
					link: null,
				},
			})
		);
		server(cookie)
			.get("/pages/backgrounds/sections/testmonials")
			.then(response => setData(response?.data?.data?.section));
	}, [dispatch]);

	const handlePicture = async e => {
		const tempValue = e?.target?.files;
		if (tempValue.length < 1) return;
		setLoading(true);

		const formData = new FormData();
		formData.append(`file`, tempValue?.[0]);

		setLoading(false);
		const imageData = await uploadServer(cookie).post("/upload", formData);

		const dataResponse = await server(cookie).put(
			"/pages/backgrounds/sections/testmonials",
			{
				section: {
					image: imageData?.data?.data?.file?.path,
				},
			}
		);

		setData(
			dataResponse?.data?.data?.sections?.find(
				section => section.slug === "testmonials"
			)
		);

		toast.success("تم رفع الصور بنجاح!");
		setLoading(false);

		return imageData?.data?.data?.file?.path;
	};

	return (
		<div>
			{loading && <Loader />}

			<div className="card">
				<div className="card-body">
					<div className="form-item">
						<label htmlFor="picture">الخلفية</label>
						<input type="file" id="picture" onChange={handlePicture} />
						<img
							src={`${process.env.REACT_APP_MAIN_URL}/${data?.image}`}
							alt="avatar"
							className="imagePreview"
						/>
					</div>
				</div>
			</div>
		</div>
	);
}
